/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import {
  LayerGroup, LeafletEvent, Marker, DivIcon,
  markerClusterGroup,
  marker,
}                             from 'leaflet';
import { IFeatureCollection }     from '@/interfaces/IFeatureCollection';
import { IParkingLastStatus } from '@/interfaces/IParkingLastStatus';
import { IModalData }         from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';
import IPosition from '@/interfaces/IPosition';
import IFeature from '@/interfaces/IFeature';
import { toRaw } from 'vue';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';
import MapIconsGeneratorService from '../MapIconsGeneratorService';


export default class ParkingLayerService extends LayerService {
  public lastStatusState: boolean = false;

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const lastUpdate: string = metaData.last_status && metaData.last_status.date_time
                       ? metaData.last_status.date_time
                       : '';

    const modalIconUrl = require(`@/assets/img/icon-layers/single-icons/marker_parking.svg`);
    const { colorClass} = this.getProperties(metaData);
    const iconCode = metaData.type.icon ? metaData.type.icon : null;

    const modalData: IModalData = {
      title: metaData.name,
      content: '',
      navigationPoint: leafletMarker,
      lastUpdate: lastUpdate,
      icon: iconCode ? MapIconsGeneratorService.resolveIconUrl(iconCode, true) : modalIconUrl,
      templateName: 'TemplateModalParking',
      metaData: metaData,
      iconClassName: `${colorClass}`,
    };

    store.commit('displayModal', modalData);
  };

  setSelected = async (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): Promise<void> => {
    store.commit('setSelectedParkingCode', metaData.id);
  };
  clearSelected = async (): Promise<void> => {
    store.commit('clearSelectedParkingCode');
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.parkings;

    return this.generateMarkerClusterLayer(points);
  };

  getProperties(metaData: any) {
    let parkingSpotsNumber: number = 0;
    let parkingSpots: string = '';
    let iconUrl: string = AssetIconService.getSvgMapIcon('its_parking_marker');
    let modalIconUrl: string = AssetIconService.getSvgModalIcon('modal_parking');
    let colorClass = '';

    if (metaData.parking_spots.length && metaData.show_availability === true) {
      const lastStatus: IParkingLastStatus = metaData.last_status as IParkingLastStatus;
      if (lastStatus !== null) {
        const sumCategoryParkinSpots = this.sumParkingCategoryPlaces(
          metaData.parking_spots, 'spots',
        );
        const sumCategoryOccupancySpots = this.sumParkingCategoryPlaces(
          metaData.last_status.occupied_spots, 'occupied',
        );

        parkingSpotsNumber = sumCategoryParkinSpots - sumCategoryOccupancySpots;
        //avoid negative values
        parkingSpotsNumber = parkingSpotsNumber < 0 ? 0 : parkingSpotsNumber;
        parkingSpots = (parkingSpotsNumber > 9) ? '9+' : parkingSpotsNumber.toString(10);
        this.lastStatusState = true;
      } else {
        this.lastStatusState = false;
        parkingSpotsNumber = 0;
        parkingSpots = '';
      }
    } else if (metaData.show_availability === true) {
      this.lastStatusState = false;
      parkingSpots = '';
    }

    if (metaData.show_availability != false && parkingSpotsNumber >= 1) {
      colorClass = 'g__color--space-free';
    }

    if (metaData.show_availability != false && parkingSpotsNumber <= 0 && !!this.lastStatusState) {
      colorClass = 'g__color--space-occupied';
    }

    // if (parkingSpotsNumber === 0 && !this.lastStatusState) {
    //   iconUrl = AssetIconService.getSvgMapIcon('its_parking_marker');
    //   modalIconUrl = AssetIconService.getSvgModalIcon('modal_parking');
    // }

    // // brak ostatniego statusu - czyli zajetosci i brak informacji o zajetosci show_availability = false
    // if (!metaData.last_status && !metaData.show_availability) {
    //   iconUrl = AssetIconService.getSvgMapIcon('its_parking_marker');
    //   modalIconUrl = AssetIconService.getSvgModalIcon('modal_parking');
    // }

    return {
      parkingSpots,
      iconUrl,
      modalIconUrl,
      colorClass,
    }
  }

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });
    
    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;
      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  public createMarker = (position: IPosition, feature: IFeature): Marker => {
    const singleMarker = marker([position.lat, position.lng], {
      icon: new DivIcon({
        html: this.generateHtmlPointTemplate(feature.properties),
        iconSize: [this.markerWidth+ 10, this.markerHeight],
        iconAnchor: [this.markerWidth / 2, this.markerHeight],
      }),
    });
    
    singleMarker.on('add', () => {
      const el = singleMarker.getElement();
      if (el) {
        el.setAttribute(
          'aria-label',
          `Pokaż szczegóły punktu ${feature.properties.name}`
        );
      }
    });
    // const { colorClass} = this.getProperties(feature.properties);

    // singleMarker.on('add', (ev) => {
    //   const button = document.createElement('button');
    //   button.textContent = 'i';
    //   button.className = `parking-marker--more ${colorClass}`;

    //   button.addEventListener('click', (event) => {
    //     // Prevent click event propagation to the marker
    //     event.stopPropagation();
    //     this.onClick(ev, feature.properties, singleMarker);
    //   });
    //   // Get the Leaflet marker's HTML element
    //   const markerIcon = singleMarker.getElement();
    //   // Append the button to the marker's icon HTML
    //   markerIcon?.appendChild(button);
    // });

    let isActive = false;
    
    singleMarker.on('click', (e) => {
      this.onClick(e, feature.properties, singleMarker);
      isActive = !isActive;
      if (isActive) {
        this.setSelected(e, feature.properties, singleMarker);
      } else {
        this.clearSelected();
      }
    });

    singleMarker.on('mouseout', (e) => {
      this.clearSelected();
    });
    singleMarker.on('mouseover', (e) => {
      this.setSelected(e, feature.properties, singleMarker);
    });

    return singleMarker;
  };

  generateClusterHtml(population: number) {
    const settings: IClusterIconSettings = {
        className: 'g__color--parking',
        insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_parking.svg`),
        population,
    };
    const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
    
    return iconHtml;
  };

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const { colorClass, parkingSpots } = this.getProperties(metaData);
    const iconCode = metaData.type.icon ? metaData.type.icon : null;
    const settings: IMarkerIconSettings = {
        className: `g__color--parking ${colorClass}`,
        insideIcon:  iconCode ? iconCode : require(`@/assets/img/icon-layers/single-icons/marker_parking.svg`),
        isBase64IconCode: iconCode ? true : false,
        populationText: parkingSpots,
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  }
}
